/* ==========================================================================
   lf-motion.js  —  PREASENS
   1) Chaque section s'anime quand le visiteur arrive dessus (toutes les pages).
   2) Les sections hors ecran sont mises en pause (marquees, videos).
   3) Bloc « Comment ca marche » : demarre a l'arrivee + glissement du doigt.
   4) Helper reutilisable : window.LFMotion.swipe(element, suivant, precedent)
   Charge en defer depuis layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var hasIO  = ('IntersectionObserver' in window);
  var reduce = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  /* Elements a ne jamais animer : barres collantes, tiroirs, pop-ups, nav */
  var SKIP = '.cph-sticky,[data-lf-nofx],[class*="drawer"],[class*="Drawer"],' +
             '[class*="popup"],[class*="Popup"],[class*="modal"],[class*="announce"]';

  /* --------------------------------------------------------------------
     1) Apparition des sections a l'arrivee du visiteur
     -------------------------------------------------------------------- */

  function done(el) {
    el.classList.remove('lf-rv', 'lf-in', 'lf-rv--fade');
    el.classList.add('lf-rv-done');
  }

  function show(el) {
    el.classList.add('lf-in');
    window.setTimeout(function () { done(el); }, 950);
  }

  function candidates(root) {
    var out  = [];
    var secs = (root || document).querySelectorAll('.shopify-section');

    for (var i = 0; i < secs.length; i++) {
      var kids = secs[i].children;

      for (var k = 0; k < kids.length; k++) {
        var el = kids[k];
        if (el.nodeType !== 1) continue;

        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' ||
            tag === 'NOSCRIPT' || tag === 'TEMPLATE') continue;

        if (el.classList.contains('lf-rv') ||
            el.classList.contains('lf-rv-done')) continue;

        if (el.matches && el.matches(SKIP)) continue;
        if (el.closest && el.closest('header,nav,footer')) continue;

        var pos = '';
        try { pos = window.getComputedStyle(el).position; } catch (e) {}
        if (pos === 'fixed') continue;

        if (el.offsetHeight < 12) continue;

        out.push(el);
      }
    }
    return out;
  }

  function arm(root) {
    var list = candidates(root);
    if (!list.length) return;

    if (reduce || !hasIO) {
      for (var n = 0; n < list.length; n++) done(list[n]);
      return;
    }

    var vh = window.innerHeight || 800;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        var t = entries[i].target;
        io.unobserve(t);
        show(t);
      }
    }, { threshold: 0.06, rootMargin: '0px 0px -10% 0px' });

    for (var j = 0; j < list.length; j++) {
      var el  = list[j];
      var top = 0;
      try { top = el.getBoundingClientRect().top; } catch (e) {}

      if (top < vh * 0.92) { done(el); continue; }

      el.classList.add('lf-rv');

      if (el.querySelector && el.querySelector(SKIP)) {
        el.classList.add('lf-rv--fade');
      }

      io.observe(el);
    }

    window.setTimeout(function () {
      var stuck = document.querySelectorAll('.lf-rv:not(.lf-in)');
      for (var s = 0; s < stuck.length; s++) {
        var r = stuck[s].getBoundingClientRect();
        if (r.top < (window.innerHeight || 800) && r.bottom > 0) show(stuck[s]);
      }
    }, 4000);
  }

  /* --------------------------------------------------------------------
     2) Etat « dans l'ecran » par section + pause des medias hors ecran
     -------------------------------------------------------------------- */

  function watchSections(root) {
    if (!hasIO) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e  = entries[i];
        var el = e.target;
        el.classList.toggle('lf-inview', e.isIntersecting);
        el.classList.toggle('lf-offscreen', !e.isIntersecting);
        try {
          el.dispatchEvent(new CustomEvent(e.isIntersecting ? 'lf:in' : 'lf:out'));
        } catch (err) {}
      }
    }, { threshold: 0, rootMargin: '100px 0px' });

    var secs = (root || document).querySelectorAll('.shopify-section');
    for (var s = 0; s < secs.length; s++) io.observe(secs[s]);
  }

  function watchVideos(root) {
    if (!hasIO) return;
    var vids = (root || document).querySelectorAll('video[autoplay], [data-lf-autoplay] video');
    if (!vids.length) return;

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        if (entries[i].isIntersecting) {
          try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
        } else {
          try { v.pause(); } catch (e) {}
        }
      }
    }, { threshold: 0.15 });

    for (var n = 0; n < vids.length; n++) io.observe(vids[n]);
  }

  /* --------------------------------------------------------------------
     3) Glissement tactile reutilisable
     -------------------------------------------------------------------- */

  function swipe(el, onNext, onPrev) {
    if (!el || el.getAttribute('data-lf-swipe') !== null) return;
    el.setAttribute('data-lf-swipe', '');

    var x0 = null, y0 = null, t0 = 0, axis = null;

    el.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); axis = null;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (x0 === null || axis) return;
      var t  = e.changedTouches[0];
      var dx = Math.abs(t.clientX - x0);
      var dy = Math.abs(t.clientY - y0);
      if (dx > 8 || dy > 8) axis = (dx > dy) ? 'x' : 'y';
    }, { passive: true });

    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t  = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      var dt = Date.now() - t0;
      x0 = null;
      if (axis !== 'x' || dt > 900) return;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      if (dx < 0) { if (onNext) onNext(); } else { if (onPrev) onPrev(); }
    }, { passive: true });

    var mx = null;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') mx = e.clientX;
    });
    el.addEventListener('pointerup', function (e) {
      if (e.pointerType !== 'mouse' || mx === null) return;
      var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) < 55) return;
      if (dx < 0) { if (onNext) onNext(); } else { if (onPrev) onPrev(); }
    });
    el.addEventListener('pointercancel', function () { mx = null; });
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* --------------------------------------------------------------------
     4) Bloc « Comment ca marche » de la fiche produit
        Par defaut il defilait des le chargement de la page, meme tout en
        haut. On reprend la main dessus :
          - il ne demarre qu'au moment ou le visiteur arrive dessus,
          - il se met en pause hors ecran ou hors onglet,
          - on peut le faire glisser au doigt sur telephone.
     -------------------------------------------------------------------- */

  function howBlock() {
    var old = document.getElementById('cph-how');
    if (!old || old.getAttribute('data-lf-how') !== null) return;

    var src = old.querySelector('#cph-how-data');
    if (!src) return;
    var data;
    try { data = JSON.parse(src.textContent); } catch (e) { return; }

    /* On remplace le bloc par une copie : cela detache d'un coup tous les
       ecouteurs d'origine. Puis on envoie un « mouseenter » sur l'ancien
       bloc, ce qui declenche son propre stop() et libere son minuteur.
       Aucun minuteur fantome ne subsiste. */
    var wrap = old.cloneNode(true);
    wrap.setAttribute('data-lf-how', '1');
    if (old.parentNode) old.parentNode.replaceChild(wrap, old);
    try { old.dispatchEvent(new MouseEvent('mouseenter')); } catch (e) {}

    var slides = wrap.querySelectorAll('.cph-how-slide');
    var dots   = wrap.querySelectorAll('.cph-how-dot');
    var num    = wrap.querySelector('.cph-how-num');
    var tEl    = wrap.querySelector('.cph-how-t');
    var dEl    = wrap.querySelector('.cph-how-d');
    var total  = slides.length || 3;

    var cur = 0, timer = null, visible = false;

    function go(i) {
      cur = ((i % total) + total) % total;
      for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('on', k === cur);
      for (var d = 0; d < dots.length; d++)   dots[d].classList.toggle('on', d === cur);
      if (num) num.textContent = String(cur + 1);
      if (tEl) tEl.textContent = (data.t && data.t[cur]) || '';
      if (dEl) dEl.textContent = (data.d && data.d[cur]) || '';
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (!visible || document.hidden || reduce) return;
      timer = window.setInterval(function () { go(cur + 1); }, 4200);
    }
    function next() { go(cur + 1); play(); }
    function prev() { go(cur - 1); play(); }

    for (var b = 0; b < dots.length; b++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          go(parseInt(btn.getAttribute('data-i'), 10) || 0);
          play();
        });
      })(dots[b]);
    }

    wrap.addEventListener('mouseenter', stop);
    wrap.addEventListener('mouseleave', play);

    swipe(wrap.querySelector('.cph-how-stage'), next, prev);

    go(0);

    if (hasIO) {
      new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          visible = es[i].isIntersecting;
          if (visible) play(); else stop();
        }
      }, { threshold: 0.35 }).observe(wrap);
    } else {
      visible = true; play();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });
  }

  window.LFMotion = { swipe: swipe, reveal: show, arm: arm };

  /* -------------------------------------------------------------------- */

  function init(root) {
    arm(root);
    watchSections(root);
    watchVideos(root);
    howBlock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var t = e.target;
    if (!t || !t.querySelectorAll) return;
    var hid = t.querySelectorAll('.lf-rv');
    for (var i = 0; i < hid.length; i++) done(hid[i]);
  });
})();